import { frontendURL } from '../../../helper/URLHelper';
import SuppliersIndex from './pages/SuppliersIndex.vue';
import SupplierDetailsView from './pages/SupplierDetailsView.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.SUPPLIERS,
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/suppliers'),
    component: SuppliersIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'suppliers_dashboard_index',
        component: SuppliersIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/suppliers/:supplierId'),
    name: 'supplier_details',
    component: SupplierDetailsView,
    meta: commonMeta,
  },
];
